/// <amd-module name="TFS/Admin/Common/Controls/RequestAccessDialog/RequestAccessDialog" />
import * as React from "react";
import { Dialog } from "VSSUI/Dialog";
import { VssComponent } from "VSS/Platform/Layout";
import { IButtonProps } from "VSSUI/Button";
import { IRequestAccessDialogProps } from "TFS/Admin/Common/Controls/RequestAccessDialog/RequestAccessDialog.Props";
import * as Resources from "TFS/Admin/Common/Controls/Resources";
import * as StringUtil from "VSS/Core/Util/String";
import { TextField } from "VSSUI/TextField";
import { ObservableValue } from "VSS/Core/Observable";
import { Link } from "VSSUI/Link";
import { Uri } from "VSS/Platform/Util/Url";
import { FormItem } from "VSSUI/FormItem";

interface IRequestAccessDialogState {
    invalidUrl: ObservableValue<boolean>;
    emptyUrl: ObservableValue<boolean>;
    userInputUrl: ObservableValue<string>;
}

export class RequestAccessDialog extends React.Component<IRequestAccessDialogProps, IRequestAccessDialogState> {
    private errorMessage: string;

    constructor(props: IRequestAccessDialogProps) {
        super(props);


        this.state = {
            invalidUrl: new ObservableValue<boolean>(false),
            emptyUrl: this.props.requestAccessUrl ? new ObservableValue<boolean>(false) : new ObservableValue<boolean>(true),
            userInputUrl: new ObservableValue<string>(this.props.requestAccessUrl)
        };
    }
    public render(): JSX.Element {

        this.errorMessage = this._getUrlErrorMessage();
        return (
            <Dialog
                className="requestaccess-dialog"
                titleProps={{ text: this.props.requestAccessTitle }}
                onDismiss={this.props.onCancel}
                footerButtonProps={this._getFooterButtonProps()}
            >
                <div className="requestaccess-dialog-paragraph small-top-margin">
                    <span>{this.props.requestAccessMessage}</span>
                    {this.props.requestAccessLearnMoreLink && (
                            <Link
                                href={this.props.requestAccessLearnMoreLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={Resources.LearnMoreLinkAriaLabel}
                            >
                            {Resources.LearnMoreLinkAriaLabel}
                            </Link>
                    )}
                </div>
                <FormItem className="top-margin" message={this.errorMessage} error={this.state.invalidUrl}>
                    <TextField
                        onChange={this._onUrlChanged}
                        value={this.state.userInputUrl}
                    />
                </FormItem>
            </Dialog>
        );
    }

    private _getFooterButtonProps(): IButtonProps[] {
        return [
            {
                text: Resources.CancelButton,
                onClick: this.props.onCancel
            },
            {        
                disabled: (this.state.invalidUrl.value || this.state.emptyUrl.value),
                primary: true,
                text: this.props.saveButtonLabel,
                onClick: () => this._onUrlSave(this.state.userInputUrl.value)
            }
        ];
    }

    private _getUrlErrorMessage() : string {
        if (this.state.userInputUrl && this.state.invalidUrl.value)
        {
            return Resources.InvalidRequestAccessUrl
        }

        return "";
    }

    private _onUrlSave = (value: string) => {
        this.props.onSave(value);
    }
    private _onUrlChanged = (event: any, value: string) => {
        this.setState({
            userInputUrl: new ObservableValue<string>(value)
        });


        if (value) 
        {
            try {
                const url = new Uri(value, { absoluteUriRequired: true });   
                if (url.absoluteUri && (StringUtil.equals(url.scheme, "http", true) || StringUtil.equals(url.scheme, "https", true))) {
                    this.setState({
                        invalidUrl: new ObservableValue<boolean>(false),                        
                        emptyUrl: new ObservableValue<boolean>(false)
                    });  
                } else {
                    this.setState({
                        invalidUrl: new ObservableValue<boolean>(true),                        
                        emptyUrl: new ObservableValue<boolean>(false)
                    });  
                }
            }
            catch (e)
            {
                this.setState({
                    invalidUrl: new ObservableValue<boolean>(true),                    
                    emptyUrl: new ObservableValue<boolean>(false)
                });
            }
        } else {
            this.setState({
                emptyUrl: new ObservableValue<boolean>(true),
                invalidUrl: new ObservableValue<boolean>(false)
            }); 
        }

        
    };
}

VssComponent.register("ms.vss-admin-web.requestaccess-dialog", RequestAccessDialog);
